import script from "./VensoOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoOrder.vue?vue&type=script&setup=true&lang=ts"

import "./VensoOrder.vue?vue&type=style&index=0&id=3d2cc16b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2cc16b"]])

export default __exports__